import { Link } from 'react-router-dom';
import { AuditDashboard, DashboardWindowName } from '../../types/audit';
import { DashboardBlock } from './useDashboardBlock';
import { dubaiDay, dubaiDaysAgo } from '../audit/auditFormat';

interface MyActivityCardProps {
  block: DashboardBlock<AuditDashboard>;
  window: DashboardWindowName;
  subjectId: string | null | undefined;
  /** The Audit screen is reachable (switch on and screen held). */
  canOpenAudit: boolean;
}

/** Spec 069 AC-A4 — "You today: N actions", linking to Audit filtered to the caller and the window. */
export default function MyActivityCard({ block, window, subjectId, canOpenAudit }: MyActivityCardProps) {
  if (block.status !== 'ok' || !block.data) return null;
  const n = block.data.myActions ?? 0;
  const text = `${window === 'TODAY' ? 'You today' : 'You, last 7 days'}: ${n} action${n === 1 ? '' : 's'}`;
  const from = window === 'TODAY' ? dubaiDay() : dubaiDaysAgo(6);
  const to = dubaiDay();
  const href = subjectId ? `/audit?from=${from}&to=${to}&admin=${encodeURIComponent(subjectId)}` : null;
  return (
    <div className="dash-my-activity" data-testid="my-activity">
      {canOpenAudit && href ? <Link to={href} className="audit-link">{text}</Link> : <span>{text}</span>}
    </div>
  );
}
